import type { ModulePiece } from "../data/modulePieces.js";

/**
 * 도감 탭 레드닷 판정 (순수) — 도감을 마지막으로 본 시점(codexSeenChapter) 이후 새로 해금된 조각이 있는지.
 *
 * 조각 해금은 `unlockChapter <= bestChapter`(bestChapter=최고 도달 챕터, 환생 유지)로 결정된다.
 * "새로 해금"은 마지막 열람 챕터(seen)와 현재 도달 챕터(best) 사이에 해금 경계를 넘은 조각 =
 * `seen < unlockChapter <= best`인 조각. 도감 진입 시 seen=best로 갱신하면 레드닷이 사라진다.
 */

/** 전체 정의의 모든 조각 해금 챕터 목록 (미지정=1). 정적이라 1회 산출해 캐시 권장. */
export function allPieceUnlockChapters(
  defs: readonly { readonly pieces: readonly ModulePiece[] }[],
): number[] {
  return defs.flatMap((d) => d.pieces.map((p) => p.unlockChapter ?? 1));
}

/** 마지막 열람(seenChapter) 이후 새로 해금된 조각이 하나라도 있으면 true (seen < unlockChapter <= best). */
export function hasNewlyUnlockedPiece(
  unlockChapters: readonly number[],
  seenChapter: number,
  bestChapter: number,
): boolean {
  return unlockChapters.some((c) => c > seenChapter && c <= bestChapter);
}
